"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IndestructibleBattleCryEffectHandler = exports.IndestructibleBattleCryEffectArgs = void 0;
const _1 = require(".");
const Duration_1 = require("../../Duration");
const enums_1 = require("../../enums");
const Registries_1 = require("../../state/Registries");
const EffectType_1 = require("../EffectType");
class IndestructibleBattleCryEffectArgs {
    constructor(toughnessIncrease, vitalityIncrease, healthIncrease) {
        this.toughnessIncrease = toughnessIncrease;
        this.vitalityIncrease = vitalityIncrease;
        this.healthIncrease = healthIncrease;
        this.__type = EffectType_1.EffectType.IndestructibleBattleCry;
        this.__typeName = "IndestructibleBattleCry";
        this.name = "Indestructible Battle Cry";
        this.harmful = false;
    }
}
exports.IndestructibleBattleCryEffectArgs = IndestructibleBattleCryEffectArgs;
let IndestructibleBattleCryEffectHandler = class IndestructibleBattleCryEffectHandler {
    apply(sequence, container, state) {
        state.meta.effectIds = container.applyBuffs({
            sequence,
            creatorId: state.creatorId,
            targetId: state.targetId,
            effects: [
                {
                    effect: new _1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Toughness, state.args.toughnessIncrease),
                    duration: Duration_1.Duration.Permanent,
                    supernatural: true
                },
                {
                    effect: new _1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Vitality, state.args.vitalityIncrease),
                    duration: Duration_1.Duration.Permanent,
                    supernatural: true
                },
                {
                    effect: new _1.MaxAttributeIncreaseEffectArgs(enums_1.AttributeType.Health, state.args.healthIncrease),
                    duration: Duration_1.Duration.Permanent,
                    supernatural: true
                }
            ]
        });
    }
    remove(sequence, container, state) {
        sequence = sequence.pushSequence("parallel");
        for (const effectId of state.meta.effectIds) {
            container.cancelEffect(sequence, effectId);
        }
    }
};
IndestructibleBattleCryEffectHandler = __decorate([
    Registries_1.Effects.register(EffectType_1.EffectType.IndestructibleBattleCry)
], IndestructibleBattleCryEffectHandler);
exports.IndestructibleBattleCryEffectHandler = IndestructibleBattleCryEffectHandler;
